<template>
	<!-- Don't change root element, root element must be an <input> -->
	<input ref="input" :class="`${class_prop} number-font`" type="text" :value="displayValue" @input="onInput"
		@blur="finishEditing" @focus="onFocus" @keyup.enter="finishEditing" />
</template>

<script>
import utils from '@/utils/index.js'

export default {
	props: {
		value: [Number, String],
		maxDecimals: {
			type: Number,
			default: 2
		},
		class_prop: {
			type: String,
			default: ''
		},
	},
	data() {
		return {
			isFocused: false,
			oldValue: null
		}
	},
	computed: {
		displayValue() {
			if (this.isFocused) return this.value
			return utils.currencyFormat(this.value)
		}
	},
	methods: {
		onInput(e) {
			const raw = this.parse(e.target.value)
			this.$emit("input", raw)
		},
		onFocus(e) {
			this.isFocused = true
			this.$emit("focusBro")

			// Keep track of old value
			this.oldValue = this.value
		},
		finishEditing() {
			this.isFocused = false

			this.$emit("blurBro")
			this.$refs.input.blur()

			// Don't emit if value hasn't changed
			if (this.value == this.oldValue) return

			this.$emit("done", this.value) // 👈 key
		},

		parse(val) {
			if (!val) return ""

			// Convert to string
			let cleaned = String(val)

			// Remove currency symbols, spaces, commas, etc.
			cleaned = cleaned.replace(/[^0-9.-]/g, "")

			// Handle multiple dots (keep only first)
			const parts = cleaned.split(".")
			if (parts.length > 2) {
				cleaned = parts[0] + "." + parts.slice(1).join("")
			}

			// limit decimals
			if (this.maxDecimals >= 0 && cleaned.includes(".")) {
				const [int, dec] = cleaned.split(".")
				cleaned = int + "." + dec.slice(0, this.maxDecimals)
			}

			// Handle multiple minus signs (keep only first at start)
			cleaned = cleaned.replace(/(?!^)-/g, "")

			// Edge cases
			if (cleaned === "-" || cleaned === "." || cleaned === "-.") {
				return cleaned
			}

			// Convert to number
			const number = Number(cleaned)

			return isNaN(number) ? "" : number
		}
	}
}
</script>